import { render, staticRenderFns } from "./CardEdit.vue?vue&type=template&id=af35730a&"
import script from "./CardEdit.vue?vue&type=script&lang=js&"
export * from "./CardEdit.vue?vue&type=script&lang=js&"
import style0 from "./CardEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports